import { X } from "lucide-react";
import { resolveUrl } from "@/lib/api";

export const TattooPhotoLightbox = ({ open, onClose, imageUrl, title, description }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center p-4 bg-black/85 backdrop-blur-sm"
      onClick={onClose}
      data-testid="tattoo-photo-lightbox"
    >
      <div className="relative max-w-md w-full" onClick={(e) => e.stopPropagation()}>
        <button
          onClick={onClose}
          aria-label="Schließen"
          data-testid="lightbox-close"
          className="absolute -top-3 -right-3 z-10 h-9 w-9 rounded-full bg-brass text-black flex items-center justify-center"
        >
          <X size={18} />
        </button>
        <div className="curio-frame">
          <div className="curio-inner">
            <img src={resolveUrl(imageUrl)} alt={title || "Gestochenes Tattoo"} className="w-full block" />
          </div>
        </div>
        {(title || description) && (
          <div className="mt-3 text-center">
            {title && <div className="font-cormorant text-xl">{title}</div>}
            {description && <div className="text-sm text-stone-300 mt-1">{description}</div>}
          </div>
        )}
      </div>
    </div>
  );
};

export default TattooPhotoLightbox;
